import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoadingService } from '../../../core/service/loading.service';

@Component({
  selector: 'app-content-loading',
  imports: [],
  templateUrl: './content-loading.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block',
  },
})
export class ContentLoadingComponent {
  readonly loadingService = inject(LoadingService);
}
